import React from "react";
import { useNavigate } from "react-router-dom";
import { useCompare } from "../hooks/useCompare";
import { RiCloseLine, RiMedicineBottleLine } from "react-icons/ri";
import { MdCompareArrows } from "react-icons/md";

export default function CompareFloatingBar() {
  const { compareItems, removeItem, clearAll, maxItems } = useCompare();
  const navigate = useNavigate();

  if (compareItems.length === 0) return null;

  const handleCompare = () => {
    const uris = compareItems.map((item) => item.uri).join(",");
    navigate(`/compare?items=${encodeURIComponent(uris)}`);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 pointer-events-none">
      <div className="max-w-[1200px] mx-auto px-4 pb-4">
        <div className="pointer-events-auto flex items-center gap-3 p-3 bg-white border border-secondary/10 rounded-2xl shadow-xl shadow-secondary/10">
          {/* Selected items */}
          <div className="flex items-center gap-2 flex-1 min-w-0 overflow-x-auto hide-scrollbar">
            {compareItems.map((item) => (
              <div
                key={item.uri}
                className="flex items-center gap-1.5 pl-2.5 pr-1.5 py-1.5 bg-primary/8 rounded-full flex-shrink-0 group"
              >
                <RiMedicineBottleLine className="size-3.5 text-primary flex-shrink-0" />
                <span className="text-12 font-text font-medium text-secondary max-w-[120px] truncate">
                  {item.name}
                </span>
                <button
                  onClick={() => removeItem(item.uri)}
                  className="flex items-center justify-center size-5 rounded-full hover:bg-primary/15 transition-colors"
                  aria-label={`Remove ${item.name} from comparison`}
                >
                  <RiCloseLine className="size-3.5 text-secondary/60 group-hover:text-secondary" />
                </button>
              </div>
            ))}

            {/* Empty slots */}
            {Array.from({ length: maxItems - compareItems.length }).map(
              (_, i) => (
                <div
                  key={`empty-${i}`}
                  className="flex items-center justify-center size-8 rounded-full border-2 border-dashed border-secondary/15 flex-shrink-0"
                >
                  <span className="text-10 text-secondary/30">+</span>
                </div>
              )
            )}
          </div>

          {/* Count and actions */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <span className="text-12 font-text text-secondary/60 hidden sm:block">
              {compareItems.length} of {maxItems}
            </span>

            <button
              onClick={clearAll}
              className="px-3 py-2 text-12 font-text font-medium text-secondary/70 hover:text-secondary rounded-lg hover:bg-secondary/5 transition-colors"
              aria-label="Clear all selected items"
            >
              Clear
            </button>

            <button
              onClick={handleCompare}
              disabled={compareItems.length < 2}
              className="inline-flex items-center gap-1.5 px-4 py-2 text-14 font-text font-medium text-white bg-primary rounded-lg hover:bg-primary/90 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              <MdCompareArrows className="size-4" />
              Compare
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
